import {CSSProperties, FC} from 'react';


export interface IIconRegisterNissanProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconRegisterNissan: FC<IIconRegisterNissanProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M11.792 15.952H8.4c-.442 0-.8-.34-.8-.762v-3.23a.744.744 0 0 1 .232-.541l5.552-5.28 2.256-2.156a.82.82 0 0 1 .568-.226.82.82 0 0 1 .568.226l3.392 3.268a.744.744 0 0 1 .237.541.744.744 0 0 1-.237.541l-2.272 2.118-5.536 5.28a.821.821 0 0 1-.568.221Zm6.68-8.198-2.264-2.156-1.136 1.082 2.264 2.156 1.136-1.082Zm-4.528 0L9.2 12.272v2.156h2.264l4.744-4.518-2.264-2.156ZM4 19V5.5c0-.667.333-1 1-1h9L12.212 6H5.5v12.5H18v-6.712l1.515-1.94V19c-.01.667-.333 1-.968 1H5c-.667 0-1-.333-1-1Z" clipRule="evenodd" />
        </svg>
    );
};
